/* CUSTOM (Shopify-Session)
 * product-gallery-inuse-order.js — In-Use auf der Produkt-Seite ersetzt
 * NUR den ersten (featured) Bild-Slot durch ein [inuse]-Bild. Andere
 * Produktbilder bleiben in der Nummer-Nav sichtbar.
 *
 * OFF (Default): erstes Slide zeigt Standard-Featured. Alle non-inuse Slides sichtbar.
 * ON:            erstes Slide bekommt img.src eines random gewaehlten [inuse]-Bildes.
 *                Nav bleibt gleich (Toggle bleibt aktiv beim Nav-Klick).
 *
 * Bei Variant-Wechsel (glaze-picker, neuer Section-DOM): Toggle auf OFF zuruecksetzen,
 * Cache leeren, [inuse]-Bilder neu einsammeln.
 *
 * Erkennung: img.alt enthaelt '[inuse]'. State: html.inuse-mode.
 */
(function () {
  var GALLERY_SEL = 'ul[id^="Slider-Gallery-"]';
  var THUMBS_SEL  = 'ul[id^="Slider-Thumbnails-"]';
  var INUSE_MARK  = '[inuse]';

  function isInuseItem(li) {
    var img = li.querySelector('img');
    return !!(img && (img.alt || '').indexOf(INUSE_MARK) >= 0);
  }

  function tag(list) {
    if (!list) return;
    Array.prototype.slice.call(list.children).forEach(function (li) {
      li.setAttribute('data-is-inuse', isInuseItem(li) ? '1' : '0');
    });
  }

  function tagAll() {
    document.querySelectorAll(GALLERY_SEL).forEach(tag);
    document.querySelectorAll(THUMBS_SEL).forEach(tag);
  }

  // Sammelt alle [inuse]-Bild-Sources aus versteckten Slides.
  function collectInuseSrcs(gallery) {
    var srcs = [];
    Array.prototype.slice.call(gallery.children).forEach(function (li) {
      if (li.getAttribute('data-is-inuse') !== '1') return;
      var img = li.querySelector('img');
      if (!img) return;
      srcs.push({
        src: img.getAttribute('src') || '',
        srcset: img.getAttribute('srcset') || '',
        sizes: img.getAttribute('sizes') || ''
      });
    });
    return srcs;
  }

  // Featured-Slot = erstes non-inuse Slide (im DOM). Nav klickt Slides direkt,
  // "featured" heisst hier: das aktuelle aktive Slide bekommt den Swap. Wir
  // implementieren aber Folkes Wunsch: NUR das erste (Position 1) Bild wird
  // getauscht — andere Slides sind Zusatzansichten, die IMMER Standard bleiben.
  function firstStandardSlide(gallery) {
    return gallery.querySelector('.product__media-item[data-is-inuse="0"]');
  }

  function packImg(img) {
    return {
      src: img.getAttribute('src') || '',
      srcset: img.getAttribute('srcset') || '',
      sizes: img.getAttribute('sizes') || ''
    };
  }

  function applyImg(img, pack) {
    if (pack.src) img.setAttribute('src', pack.src);
    if (pack.srcset) img.setAttribute('srcset', pack.srcset); else img.removeAttribute('srcset');
    if (pack.sizes) img.setAttribute('sizes', pack.sizes); else img.removeAttribute('sizes');
  }

  function swapFeatured(on) {
    document.querySelectorAll(GALLERY_SEL).forEach(function (gallery) {
      var slide = firstStandardSlide(gallery);
      if (!slide) return;
      var img = slide.querySelector('img');
      if (!img) return;

      if (on) {
        var inuseSrcs = collectInuseSrcs(gallery);
        if (!inuseSrcs.length) return;
        if (!slide.dataset.origPack) {
          slide.dataset.origPack = JSON.stringify(packImg(img));
        }
        // Random pick — bei jedem Aktivieren ein neuer Pick.
        var pick = inuseSrcs[Math.floor(Math.random() * inuseSrcs.length)];
        applyImg(img, pick);
      } else {
        if (slide.dataset.origPack) {
          try { applyImg(img, JSON.parse(slide.dataset.origPack)); } catch (e) {}
        }
      }
    });
  }

  function isOn() {
    return document.documentElement.classList.contains('inuse-mode');
  }

  // Zwingt den Toggle-Button + Zustand auf OFF. Wird bei Variant-Wechsel gerufen,
  // damit der User erst wieder die Standard-Bilder sieht.
  function forceOff() {
    var wasOn = isOn();
    // Toggle-Modul hart resetten — sonst haengt __memState auf true und der
    // naechste Klick tippt auf OFF statt ON (User braucht 2 Klicks).
    if (window.inuseToggle && typeof window.inuseToggle.reset === 'function') {
      window.inuseToggle.reset();
    } else {
      // Fallback: State-Klasse + Button-UI manuell.
      document.documentElement.classList.remove('inuse-mode');
      document.querySelectorAll('.inuse-toggle').forEach(function (btn) {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-pressed', 'false');
        btn.setAttribute('aria-checked', 'false');
      });
    }
    tagAll();
    if (wasOn) swapFeatured(false);
    fireModeChanged();
  }

  function fireModeChanged() {
    document.documentElement.dispatchEvent(new CustomEvent('inuse-mode-changed'));
  }

  // Springt zum ersten Standard-Slide (Slot 1) via Origin-Thumbnail-Klick.
  // Wichtig: wenn User auf Bild 2/3 ist und Toggle klickt, muss Slot 1 aktiv
  // werden, damit er den [inuse]-Swap sieht.
  function jumpToFirstSlot() {
    document.querySelectorAll(GALLERY_SEL).forEach(function (gallery) {
      var first = firstStandardSlide(gallery);
      if (!first || first.classList.contains('is-active')) return;
      var mediaId = first.getAttribute('data-media-id');
      if (!mediaId) return;
      var thumb = document.querySelector('[data-target="' + mediaId + '"] .thumbnail');
      if (thumb) thumb.click();
    });
  }

  function onModeChange() {
    swapFeatured(isOn());
    jumpToFirstSlot();
    fireModeChanged();
  }

  function init() {
    tagAll();
    if (isOn()) swapFeatured(true);
    fireModeChanged();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // html.inuse-mode Umschaltung.
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      if (records[i].attributeName === 'class') { onModeChange(); return; }
    }
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

  // Bei Variant-Wechsel (glaze-picker rendert Media neu): Toggle zwangs-OFF.
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        var hit = (n.matches && (n.matches(GALLERY_SEL) || n.matches(THUMBS_SEL)))
          || (n.querySelector && n.querySelector(GALLERY_SEL + ', ' + THUMBS_SEL));
        if (hit) { forceOff(); return; }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
